import type { ColumnDef } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
import type { ContactOrderTableRow } from "../../../_logic/contact-orders-contract"
import type { ContactOrderPlanningFilterState } from "./filters"
import type { BatchDateRangeFilter } from "../../../_logic/filter-values"

export const CONTACT_ORDER_APPOINTMENT_COLUMNS: ColumnDef[] = [
  { id: "order", label: "Auftrag" },
  { id: "postage", label: "Briefzustellung" },
  { id: "postalAnnouncement", label: "Postalische Ankündigung" },
  { id: "digitalAnnouncement", label: "Digitale Ankündigung" },
]

export const CONTACT_ORDER_STATUS_OPTIONS = [
  { value: "pending", label: "Offen" },
  { value: "all", label: "Alle" },
  { value: "created", label: "Hat Plan" },
]

export const CONTACT_ORDER_RECIPIENT_STATUS_OPTIONS = [
  { value: "", label: "Alle Ansprechpartner" },
  { value: "selected", label: "Ansprechpartner gewählt" },
  { value: "missing", label: "Keine Ansprechpartner" },
]

export const buildContactOrderLoadingRows = (
  loading: boolean,
  count: number,
): ContactOrderTableRow[] =>
  loading
    ? Array.from({ length: Math.max(1, count || 5) }, (_, index) => ({
        id: `loading-${index}`,
        isLoading: true,
      }))
    : []

export const buildContactOrderTableLoading = ({
  loading,
  previewLoading,
}: {
  loading: boolean
  previewLoading: boolean
}) => Boolean(loading || previewLoading)

export const buildSkippedWarningText = (skippedPendingCount: number) =>
  skippedPendingCount === 1
    ? "Für 1 Termin ist kein Ankündigungsplan aktiv."
    : `Für ${skippedPendingCount} Termine ist kein Ankündigungsplan aktiv.`

export type ContactOrderFilterField = {
  id: keyof ContactOrderPlanningFilterState & string
  type: "text" | "select" | "dateRange"
  placeholder: string
  value: string | BatchDateRangeFilter
  options?: Array<{ value: string; label: string }>
  enabled: boolean
}

export const buildContactOrderFilterFields = ({
  filters,
  rowCount,
  hasUsefulSearch,
  hasUsefulSelectOptions,
}: {
  filters: ContactOrderPlanningFilterState
  rowCount: number
  hasUsefulSearch: (rowCount: number) => boolean
  hasUsefulSelectOptions: (
    options: Array<{ value: string; label: string }>,
    rowCount: number,
  ) => boolean
}): ContactOrderFilterField[] => [
  {
    id: "search",
    type: "text",
    placeholder: "Suche",
    value: filters.search,
    enabled: hasUsefulSearch(rowCount),
  },
  {
    id: "status",
    type: "select",
    placeholder: "Status",
    value: filters.status,
    options: CONTACT_ORDER_STATUS_OPTIONS,
    enabled: hasUsefulSelectOptions(CONTACT_ORDER_STATUS_OPTIONS, rowCount),
  },
  {
    id: "recipientStatus",
    type: "select",
    placeholder: "Ansprechpartner",
    value: filters.recipientStatus,
    options: CONTACT_ORDER_RECIPIENT_STATUS_OPTIONS,
    enabled: hasUsefulSelectOptions(CONTACT_ORDER_RECIPIENT_STATUS_OPTIONS, rowCount),
  },
]

export const buildContactOrderMetricsVisible = ({
  hasEstimate,
  pendingCount,
  skippedPendingCount,
  loading = false,
}: {
  hasEstimate: boolean
  pendingCount?: number
  skippedPendingCount: number
  loading?: boolean
}) => Boolean(hasEstimate || pendingCount || skippedPendingCount || loading)
